<template>
	<v-container fluid>
		<v-card class="gradient-primary pa-3" flat>
			<div class="header-content">
				<div class="header-left">
					<v-avatar size="32" color="white" class="mr-4">
						<v-icon color="dark" size="24">mdi-mouse</v-icon>
					</v-avatar>
					<div style="flex: 1 1 0%;">
						<h1 class="text-h4 font-weight-bold white--text mb-1">
							Accesorios de Equipos
						</h1>
					</div>
				</div>
				<v-text-field v-model="filter.Search" placeholder="Buscar accesorios..."
					prepend-inner-icon="mdi-magnify" outlined dense hide-details class="search-field-header" clearable
					dark color="white" @click:clear="filter.Search = ''">
				</v-text-field>
			</div>
		</v-card>

		<s-crud :config="config" title="Accesorios" :filter="filter" add edit remove noSearch @save="saveAccessory"
			@addEvent="addEvent($event)" @dblClick="edit($event)" height="450" ref="crudComponentes" exportExcel
			@exportExcel="exportExcel()">

			<template v-slot:filter>
				<v-container fluid>
					<v-row dense class="pb-2" align="end">
						<v-col cols="12" class="s-col-form" sm="6" md="3">
							<s-select-definition :def="1543" label="Tipo" v-model="filter.EayAccessory" searchable
								clearable />
						</v-col>
						<v-col cols="12" class="s-col-form" sm="6" md="4">
							<v-switch label="Solo Disponibles" v-model="filter.EayOnlyAvailable" dense hide-details
								:true-value="1" :false-value="0" style="display: inline-block;" color="primary" />
						</v-col>
						<v-col cols="12" class="s-col-form d-flex justify-end" sm="12" md="5" lg="5"
							v-if="selectedAccessoryCheckIds.length > 0">
							<v-btn class="font-weight-medium rounded-lg" color="primary" small dark elevation="2"
								@click="historyAssignaments(null)">
								Asignar Accesorios
								<v-chip class="px-1 ml-1 white--text font-weight-bold" x-small pill color="white"
									outlined>
									{{ selectedAccessoryCheckIds.length }}
								</v-chip>
							</v-btn>
						</v-col>
					</v-row>
				</v-container>
			</template>

			<template v-slot="props">
				<v-row dense>
					<v-col cols="12" class="s-col-form" md="3">
						<s-select-definition :def="1543" label="Accesorio" v-model="form.EayAccessory" searchable
							:add="$fun.isAdmin()" />
					</v-col>
					
					<v-col cols="12" class="s-col-form" md="3" v-if="!form.EayObservation && form.EayAccessory != SIM_CARD_TYPE_ID">
						<s-select-definition 
							:def="1533" 
							label="Marca" 
							v-model="form.EayBrand" 
							searchable 
							clearable
							:add="$fun.isAdmin()" 
						/>
					</v-col>
					<v-col cols="12" class="s-col-form" md="3" v-if="!form.EayObservation && form.EayAccessory != SIM_CARD_TYPE_ID">
						<v-row dense no-gutters align="center">
							<v-col v-if="showAddModelInput" cols="12">
								<v-text-field
									v-model="newModelName"
									label="Nuevo Modelo"
									dense
									hide-details
									autofocus
									@keyup.enter="saveNewModel"
									@keyup.esc="showAddModelInput = false; newModelName = ''"
								>
									<template v-slot:append>
										<v-btn icon x-small color="success" @click="saveNewModel">
											<v-icon>mdi-check</v-icon>
										</v-btn>
										<v-btn icon x-small color="error" @click="showAddModelInput = false; newModelName = ''">
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</template>
								</v-text-field>
							</v-col>
							<v-col v-else>
								<v-autocomplete
									:items="equipmentModels"
									item-text="EmdName"
									item-value="EmdID"
									label="Modelo"
									v-model="form.EayModel"
									clearable
									hide-details
								/>
							</v-col>
							<v-col v-if="!showAddModelInput && $fun.isAdmin()" cols="auto" class="pl-1">
								<v-btn icon x-small color="primary" @click="showAddModelInput = true; newModelName = ''">
									<v-icon>mdi-plus-circle</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" class="s-col-form" md="3" v-if="!form.EayObservation">
						<s-text :disabled="form.EayAccessory != SIM_CARD_TYPE_ID && form.EayID ? true : false" :label="form.EayAccessory == SIM_CARD_TYPE_ID ? 'IMEI' : 'Serie'" v-model="form.EaySerie" />
				</v-col>
				<!-- SIM CARD: Phone Number -->
						<v-col cols="12" class="s-col-form" md="3" v-if="form.EayAccessory == SIM_CARD_TYPE_ID && !form.EayObservation">
							<s-text label="Número de Celular" v-model="form.EayPhoneNumber" />
						</v-col>
						<!-- SIM CARD: PUK -->
				<v-col cols="12" class="s-col-form" md="3" v-if="form.EayAccessory == SIM_CARD_TYPE_ID && !form.EayObservation">
					<s-text label="PUK" v-model="form.EayPuk" />
				</v-col>
				<!-- SIM CARD: Plan -->
				<v-col cols="12" class="s-col-form" md="6" v-if="form.EayAccessory == SIM_CARD_TYPE_ID && !form.EayObservation">
					<s-select
						label="Plan de Telefonía"
						v-model="form.CppID"
						:items="itemsPhonePlans"
						:item-text="item => item.OperatorName + ' - ' + item.CppName"
						item-value="CppID"
						clearable
					/>
				</v-col>
				<!-- Plan summary -->
				<v-col cols="12" v-if="form.EayAccessory == SIM_CARD_TYPE_ID && selectedPlan" md="12">
					<div class="mt-1 pa-3 rounded grey lighten-4">
						<v-row dense>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Min. Nacionales</div><div class="font-weight-medium"><v-chip v-if="selectedPlan.CppNationalMins >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip><span v-else>{{ selectedPlan.CppNationalMins || 0 }} Min</span></div></v-col>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Min. Internacionales</div><div class="font-weight-medium"><v-chip v-if="selectedPlan.CppIntMins >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip><span v-else>{{ selectedPlan.CppIntMins || 0 }} Min</span></div></v-col>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Datos Nac. (GB)</div><div class="font-weight-medium"><v-chip v-if="selectedPlan.CppNationalData >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip><span v-else>{{ selectedPlan.CppNationalData || 0 }} GB</span></div></v-col>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Datos Int. (GB)</div><div class="font-weight-medium"><v-chip v-if="selectedPlan.CppIntData >= 9999" x-small color="primary" text-color="white">ILIMITADO</v-chip><span v-else>{{ selectedPlan.CppIntData || 0 }} GB</span></div></v-col>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Roaming</div><div class="font-weight-medium">{{ selectedPlan.CppHasRoaming ? 'Sí' : 'No' }}</div></v-col>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Precio</div><div class="font-weight-medium">{{ selectedPlan.CppPrice ? 'S/ ' + selectedPlan.CppPrice : '-' }}</div></v-col>
							<v-col cols="6" md="3"><div class="text-caption grey--text">Descuento</div><div class="font-weight-medium">{{ selectedPlan.CppDiscount ? '% ' + selectedPlan.CppDiscount : '-' }}</div></v-col>
						</v-row>
					</div>
				</v-col>
					<!-- CHARGER: Potencia -->
					<v-col cols="12" class="s-col-form" md="3" v-if="form.EayAccessory == CHARGER_TYPE_ID && !form.EayObservation">
						<s-text label="Potencia (W)" v-model="form.EayWattage" />
					</v-col>
					<!-- CHARGER: Tipo de Cable -->
					<v-col cols="12" class="s-col-form" md="4" v-if="form.EayAccessory == CHARGER_TYPE_ID && !form.EayObservation">
						<s-select-definition :def="1694" label="Tipo de Cable" v-model="form.EayCableType" clearable />
					</v-col>
					<!-- CHARGER: Cable de Datos -->
					<v-col cols="12" class="s-col-form" md="5" v-if="form.EayAccessory == CHARGER_TYPE_ID && !form.EayObservation">
						<v-switch label="¿Es Cable de Datos?" v-model="form.EayHasDataCable" inset color="primary" dense class="mt-0" hide-details />
					</v-col>
				<v-col cols="12" class="s-col-form" md="9" v-if="showDescription()">
					<s-text label="Descripción" v-model="form.EayObservation" />
				</v-col>
				
				<v-col cols="12" class="s-col-form" md="3">
					<s-select-definition :def="1583" label="Tipo de Tenencia" v-model="form.EayTypeTenure" clearable />
				</v-col>
					<v-col cols="12" class="s-col-form" md="3">
						<s-select-definition :def="1593" label="Estado" v-model="form.EayState" />
					</v-col>
					<v-col cols="12" class="s-col-form" md="3">
						<s-date v-model="form.EayDate" label="Fecha Adquisición" clearable />
					</v-col>
				</v-row>
			</template>

			<template v-slot:accion="{ row }">
				<v-checkbox v-if="row.EayStatusAssignament == 1 && [1, 2].includes(row.EayState)"
					v-model="selectedAccessoryCheckIds" @change="changeCheckbox(row)" class="mt-0 pt-0"
					:value="row.EayID" hide-details>
				</v-checkbox>
			</template>

			<template v-slot:item.EayAccessoryName="{ item }">
				{{ item.EayAccessoryName }}
				<template v-if="item.EayObservation">
					<h5 class="text-caption">{{ item.EayObservation }}</h5>
				</template>
			</template>

			<template v-slot:item.CgeTypeEquipmentName="{ item }">
				<v-row align="center" dense no-gutters style="gap:4px; padding: 4px; flex-wrap: nowrap;">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" fab x-small color="primary" @click="historyAssignaments(item)">
								<v-icon>mdi-cellphone-link</v-icon>
							</v-btn>
						</template>
						<span>Equipos Vinculados</span>
					</v-tooltip>

					<v-chip x-small dark outlined :color="item.EayStatusAssignament == 1 ? 'success' : item.EayStatusAssignament == 3 ? 'warning' : 'red'"
						class="pa-2 rounded-xl font-weight-semibold">
						{{ item.EayStatusAssignament == 1 ? 'LIBRE' : item.EayStatusAssignament == 3 ? 'NO DISPONIBLE' : 'ASIGNADO' }}
					</v-chip>
				</v-row>
			</template>

			<template v-slot:item.EayState="{ item }">
				<v-chip v-if="item.EayState == 1 || item.EayState == 2" x-small dark :outlined="item.EayState == 1"
					color="success" class="pa-2 rounded-xl font-weight-semibold">
					{{ item.EayStateName }}
				</v-chip>
				<v-chip v-else-if="item.EayState == 3 || item.EayState == 4" x-small dark outlined color="red"
					class="pa-2 rounded-xl font-weight-semibold">
					{{ item.EayStateName }}
				</v-chip>
				<v-chip v-else x-small dark outlined color="primary" class="pa-2 rounded-xl font-weight-semibold">
					{{ item.EayStateName }}
				</v-chip>
			</template>
<template v-slot:item.EayHasDataCable="{ item }">
                <v-chip v-if="item.EayHasDataCable" x-small color="success" text-color="white" class="px-2">Sí</v-chip>
                <v-chip v-else x-small color="grey" text-color="white" class="px-2">No</v-chip>
            </template>
		</s-crud>

		<!-- realizar carga masiva -->
		<v-dialog v-if="dialogUploadMassive" v-model="dialogUploadMassive">
			<v-card>
				<upload-massive-component
					@closeDialogUploadMassive="closeDialogUploadMassive()"></upload-massive-component>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-model="dialogHistory" v-if="dialogHistory" max-width="900px">
			<v-card class="rounded-xl">
				<div class="modern-header">
					<div class="header-content">
						<div class="header-left">
							<v-icon class="header-icon" size="28" color="white">mdi-cellphone-link</v-icon>
							<h2 class="header-title" style="text-transform: uppercase; font-size: 1.2rem">
								Dispositivos Vinculados
							</h2>
						</div>
						<div class="header-actions">
							<v-btn icon large class="close-btn" @click="dialogHistory = false">
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</div>


				<!-- <div class="modern-header">
					<div class="header-content">
						<div class="header-left">
							<v-icon class="header-icon" size="28" color="white">mdi-cellphone-link</v-icon>
							<h2 class="header-title" style="text-transform: uppercase">
								Dispositivos Vinculados
							</h2>
						</div>
						<div class="header-actions">
							<v-btn icon large class="close-btn" @click="dialogHistory = false">
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</div> -->

				<v-col cols="12" md="5"
					v-if="(form.EayStatusAssignament == 1 && [1, 2].includes(form.EayState)) || form.EayID == 0">
					<v-row dense align="end">
						<s-text class="flex-grow-1" v-model="CgeSerie" label="Serie del equipo"
							@keyupEnter="searchCgeEquipment"></s-text>
						<v-btn color="primary" fab x-small dark elevation="2" @click="searchCgeEquipment">
							<v-icon>mdi-feature-search-outline</v-icon>
						</v-btn>
					</v-row>
				</v-col>

				<div v-else class="pa-3 d-flex justify-start">
					<v-alert colored-border border="left" elevation="2"
						:color="[1, 2].includes(form.EayState) ? 'warning' : 'error'" class="rounded-xl mb-0">
						<v-row align="center" no-gutters>
							<v-col cols="auto pl-2">
								<v-icon style="transform: scale(3);"
									:color="[1, 2].includes(form.EayState) ? 'warning' : 'error'">mdi-information</v-icon>
							</v-col>
							<v-col class="grow pl-5">
								<h3 class="text-h6 font-weight-medium"
									:class="[1, 2].includes(form.EayState) ? 'warning--text' : 'error--text'">
									{{
										[1, 2].includes(form.EayState) ?
											'ACCESORIO ASIGNADO' : 'NO DISPONIBLE PARA ASIGNACIÓN'
									}}
								</h3>
								<div class="text-caption grey--text text-uppercase" style="max-width: 380px;">
									Este accesorio se encuentra asignado a un equipo, para una nueva asignación,
									primero debe generar devolución.
								</div>
							</v-col>
						</v-row>
					</v-alert>
				</div>

				<v-container fluid class="px-4 pt-0 pb-4">
					<v-card flat class="transparent">
						<v-card-title class="text-base font-weight-bold px-0 py-0" v-if="filteredEquipments.length > 0">
							<v-icon left color="primary" large>mdi-laptop</v-icon>
							Equipos de Cómputo Encontrados
							<v-spacer></v-spacer>
							<v-chip small color="primary" outlined class="px-2">
								{{ filteredEquipments.length }}
								{{ filteredEquipments.length === 1 ? 'equipo' : 'equipos' }}
							</v-chip>
						</v-card-title>

						<div class="equipment-grid pa-0 pt-2" v-if="filteredEquipments.length > 0">
							<v-card v-for="equipment in filteredEquipments" :key="equipment.CgeID"
								class="rounded-xl equipment-card"
								:class="{ 'selected-card': form.CgeID === equipment.CgeID }"
								:elevation="form.CgeID === equipment.CgeID ? 8 : 2"
								@click="selectEquipment(equipment.CgeID)">
								<v-card-text class="pa-2">
									<v-row align="center" no-gutters>
										<v-col cols="auto" class="">
											<v-radio :value="equipment.CgeID" color="primary" class="mt-0"
												style="display: none;"></v-radio>
										</v-col>

										<v-col>
											<v-row no-gutters>
												<v-col cols="12">
													<div class="block w-full text-center mx-auto">
														<v-icon style="scale: calc(2);"
															:color="form.CgeID === equipment.CgeID ? 'primary' : 'grey'"
															class="text-center">
															{{ getEquipmentIcon(equipment.CgeTypeEquipmentName) }}
														</v-icon>
													</div>
													<h5 class="text-xs font-weight-medium text-center mt-2">
														{{ equipment.CgeTypeEquipmentName }}
														{{ equipment.CgeBrandName }}
														{{ equipment.CgeModelName }}
													</h5>

													<v-col cols="12" class="d-flex align-center pa-1">
														<v-icon small color="grey darken-1"
															class="mr-2">mdi-barcode</v-icon>
														<span class="text-caption grey--text text--darken-3">
															{{ equipment.CgeSerie }}
														</span>
													</v-col>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</div>
					</v-card>

					<v-card-actions v-if="filteredEquipments.length > 0" class="pa-0 py-2">
						<v-spacer></v-spacer>
						<v-btn class="rounded-lg" color="primary" @click="saveAsignacion"
							:disabled="!form.CgeID">VINCULAR</v-btn>
					</v-card-actions>

					<v-data-table :headers="headersEquipmentAssignament" :items="filtereditemsEquipmentAssignament"
						dense class="modern-table" :items-per-page="15" item-key="AahcID">

						<template v-slot:item.EayStatus="{ item }">
							<v-chip v-if="item.EayStatus" x-small outlined
								:color="[1, 2].includes(item.EayStatus) ? 'success' : 'error'" class="pl-2 pr-2">
								{{ item.EayStatusDevolutionName }}
							</v-chip>

							<v-tooltip v-else bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn color="error" fab x-small dark elevation="2"
										@click="openModalDevolution(item)" v-bind="attrs" v-on="on">
										<v-icon>mdi-attachment-remove</v-icon>
									</v-btn>
								</template>
								<span>Liberar</span>
							</v-tooltip>
						</template>

						<template v-slot:item.SecCreate="{ item }">
							{{ $fun.formatDateView(item.SecCreate) }}
						</template>

						<template v-slot:item.DateDevolution="{ item }">
							{{ $fun.formatDateView(item.DateDevolution) }}
						</template>
					</v-data-table>
				</v-container>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-model="dialogUnassignament" v-if="dialogUnassignament" max-width="400px">
			<v-card class="rounded-xl">
				<div class="modern-header">
					<div class="header-content">
						<div class="header-left">
							<v-icon class="header-icon" size="28" color="white">mdi-link-off</v-icon>
							<h2 class="header-title" style="text-transform: uppercase;font-size: 1.2rem">
								Devolución de Accesorio
							</h2>
						</div>
						<div class="header-actions">
							<v-btn icon large class="close-btn" @click="dialogUnassignament = false">
								<v-icon color="white">mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</div>

				<v-col>
					<v-row>
						<v-col cols="12" class="s-col-form">
							<s-select-definition :def="1593" :add="$fun.isAdmin()" label="Estado Devolución" clearable
								v-model="form.EayStateDevolution" />
						</v-col>
						<v-col cols="12">
							<s-textarea label="Observación" v-model="form.AahObservation" :rows="1" />
						</v-col>
					</v-row>
					<v-row justify="end" align="center">
						<v-card-actions>
							<v-btn class="rounded-lg" color="primary"
								@click="saveDevolutionAccessory">Desvincular</v-btn>
						</v-card-actions>
					</v-row>
				</v-col>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import _service from "@/services/InformationTechnology/EquimentAccessoryService";
import _serviceTicEquipment from "@/services/InformationTechnology/TicEquipmentService";
import TicPhonePlanService from "../../../services/InformationTechnology/TicPhonePlanService";
import UploadMassiveComponent from './UploadMassiveComponent.vue';
import EquipmentModelService from "../../../services/InformationTechnology/EquipmentModelService";

export default {
	components: {
		UploadMassiveComponent,
	},
	data() {
		return {
			SIM_CARD_TYPE_ID: 14,
            CHARGER_TYPE_ID: 2,
			CgeSerie: '',
			dialogUploadMassive: false,
			dialogAssignament: false,
			dialogHistory: false,
			dialogUnassignament: false,
			isSaving: false,
			openDialog: false,
			equipmentModels: [],
			showAddModelInput: false,
			newModelName: '',
			filteredEquipments: [],
			selectedAccessoryCheck: [],
			itemsPhonePlans: [],
			selectedAccessoryCheckIds: [],
			filter: {
				Search: '',
				EayOnlyAvailable: 0,
				EayAccessory: null,
			},
			form: {
				EayID: 0,
				EayAccessory: 0,
				EayBrand: 0,
				EayModel: 0,
				EaySerie: '',
				EayState: 0,
				EayObservation: '',
				EayDate: '',
				EayTypeTenure: 0,
				CppID: null,
				EayPuk: '',
				EayPhoneNumber: '',
                    EayWattage: '',
                    EayCableType: null,
                    EayHasDataCable: false,
				CgeID: null,
				SecStatus: 1,
				UsrCreateID: null,
			},
			config: {
				model: {
					EayID: "ID",
				},
				headers: [
					{ text: "Acción", value: "accion", width: 50 },
					{ text: "ID", value: "EayID", width: 50 },
					{ text: "Nombre", value: "EayAccessoryName" },
					{ text: "Marca", value: "EayBrandName", width: 100 },
					{ text: "Modelo", value: "EayModelName", width: 120 },
					{ text: "Serie", value: "EaySerie", width: 90 },
						{ text: "PUK", value: "EayPuk", width: 70 },
						{ text: "Plan", value: "CppName" },
					{ text: "Estado", value: "EayState", width: 70, align: "center" },
					{ text: "Tenencia", value: "EayTypeTenureName", width: 100 },
					{ text: "Asignación", value: "CgeTypeEquipmentName", align: "center", width: 150 },
				],
				service: _service,
			},
			headersEquipmentAssignament: [
				{ text: "ID", value: "AahcID", width: 50 },
				{ text: "Equipo", value: "CgeTypeEquipmentName", width: 120, sortable: false },
				{ text: "Marca", value: "CgeBrandName", width: 120, sortable: false },
				{ text: "Modelo", value: "CgeModelName", width: 120, sortable: false },
				{ text: "Serie", value: "CgeSerie", width: 120, sortable: false },
				{ text: "Estado Devolución", value: "EayStatus", width: 120, align: "center", sortable: false },
				{ text: "Detalle Devolución", value: "AahObservation", sortable: false },
				{ text: "Fecha Devolución", value: "DateDevolution", width: 70, align: "center", sortable: false },
				{ text: "Fecha asignación", value: "SecCreate", width: 70, align: "center", sortable: false },
			],
			filtereditemsEquipmentAssignament: []
		}
	},
	computed: {
		selectedPlan() {
			if (!this.form.CppID || !this.itemsPhonePlans.length) return null;
			var self = this;
			return this.itemsPhonePlans.find(function (p) { return p.CppID === self.form.CppID; }) || null;
		},
	},
	watch: {
		"form.EayAccessory": {
			handler: function (newVal) {
				if (newVal == this.SIM_CARD_TYPE_ID) {
					this.form.EayBrand = 0;
					this.form.EayModel = 0;
					this.fetchAllPhonePlans();
				}
			},
		},
		"form"(item) {
			this.showDescription();
			this.isSaving = item.CgeID ? true : false;
		},
		"filter.EayAccessory"(newVal) {
			this.updateTableHeaders(newVal);
			const modelHeader = this.config.headers.find(
				(h) => h.value === "EayModelName",
			);
			const serieHeader = this.config.headers.find(
				(h) => h.value === "EaySerie",
			);
			if (modelHeader) {
				modelHeader.text =
					newVal == this.SIM_CARD_TYPE_ID ? "IMEI" : "Modelo";
			}
			if (serieHeader) {
				serieHeader.text =
					newVal == this.SIM_CARD_TYPE_ID ? "Numero de celular" : "Serie";
			}
		},
	},
	methods: {
		addEvent() {
			this.form = {
				EayID: 0,
				EayAccessory: 0,
				EayBrand: 0,
				EayModel: 0,
				EaySerie: '',
				EayState: 0,
				EayObservation: '',
				EayDate: '',
				EayTypeTenure: 0,
				CppID: null,
				EayPuk: '',
				EayPhoneNumber: '',
                    EayWattage: '',
                    EayCableType: null,
                    EayHasDataCable: false,
				CgeID: null,
				SecStatus: 1,
				UsrCreateID: null,
			};
		},
		saveAccessory() {
			if (this.form.EayAccessory == null) {
				this.$fun.alert("Seleccione tipo de accesorio", "info");
				return;
			}

			const validateDescripcion = this.showDescription();
			if (validateDescripcion && this.form.EayObservation.trim() == '') {
				this.$fun.alert("Ingrese descripción del accesorio", "info");
				return;
			}
			if (!validateDescripcion && this.form.EayBrand == 0 && this.form.EayAccessory != this.SIM_CARD_TYPE_ID) {
				this.$fun.alert("Seleccione marca de accesorio", "info");
				return;
			}
			if (!validateDescripcion && this.form.EayState == 0) {
				this.$fun.alert("Seleccione estado de accesorio", "info");
				return;
			}
			if (this.form.EayTypeTenure == null || this.form.EayTypeTenure == 0) {
				this.$fun.alert("Seleccione tipo de tenencia", "info");
				return;
			}

			const mensaje = this.form.EayID == 0 ? "Registrar nuevo accesorio" : "Actualizar accesorio";
			this.$fun.alert(`${mensaje}?`, "question").then((res) => {
				if (res.value) {
					this.save()
				}
			})
		},
		save() {
			if (this.form.EayAccessory == this.SIM_CARD_TYPE_ID) { this.form.EayBrand = 0; this.form.EayModel = 0; }
				this.form.UsrCreateID = this.$fun.getUserID();
			this.form.EaySerie = (this.form.EaySerie == null || this.form.EaySerie == '') ? null : this.form.EaySerie.trim().toUpperCase();
			_service.save(this.form, this.$fun.getUserID()).then((response) => {
				this.CgeSerie = '';
				this.filteredEquipments = [];
				this.openDialog = false;
				this.isSaving = false;
				this.dialogUnassignament = false;

				if (response.status == 200) {
					this.$refs.crudComponentes.refresh();
					const alerta = this.form.EayID == 0 ? "Agregado Correctamente" : "Actualizado Correctamente";
					this.$fun.alert(alerta, "success");
				}
			});
		},
		edit(accesory) {
				this.form = { ...accesory };
				if (accesory.EayAccessory == this.SIM_CARD_TYPE_ID) {
					this.fetchAllPhonePlans();
				}
				},
		showDescription() {
			if (!this.form.EayBrand && !this.form.EayModel && !this.form.EaySerie) {
				return true;
			} else {
				return false;
			}
		},
		searchCgeEquipment() {
			if (this.CgeSerie == '' || this.CgeSerie == null || this.CgeSerie.length < 3) {
				this.filteredEquipments = [];
				this.form.CgeID = null;
				this.$fun.alert("Ingresar serie válida del equipo", "info");
				return;
			}

			_serviceTicEquipment.findBySerie({ Search: this.CgeSerie }, this.$fun.getUserID()).then((response) => {
				this.filteredEquipments = response.status == 200 ? response.data : [];
			});
		},
		saveAsignacion() {
			if (this.form.CgeID == null) {
				this.$fun.alert("Seleccione un equipo", "info");
				return;
			}

			if (this.form.EayID == undefined && this.selectedAccessoryCheck.length == 0) {
				this.$fun.alert("Seleccione al menos un accesorio", "info");
				return;
			}

			// Si hay form, Es porque ingresado desde accesorio
			if (this.form.EayID) {
				const history = {
					AahcID: 0,
					EayID: this.form.EayID,
					CgeID: this.form.CgeID,
					AahObservation: null,
					EayStatus: null,
					DateDevolution: null,
					SecStatus: 1,
					UsrCreateID: this.$fun.getUserID()
				}

				const messageResult = "Accesorio asignado correctamente"
				this.$fun.alert("Asignar Accesorio al equipo seleccionado ?", "question").then((res) => {
					if (res.value) {
						this.saveOrUpdateHistory([history], messageResult, () => {
							this.CgeSerie = '';
							this.form.CgeID = null;
							this.form.EayStatusAssignament = 2;
							this.isSaving = false;
							this.filteredEquipments = [];
							if (this.selectedAccessoryCheckIds.includes(this.form.EayID)) {
								this.selectedAccessoryCheckIds = this.selectedAccessoryCheckIds.filter(id => id != this.form.EayID)
								this.selectedAccessoryCheck = this.selectedAccessoryCheck.filter(accesory => accesory.EayID != this.form.EayID)
							}
							this.loadDevicesHistoryAccesory(history.EayID, () => this.$refs.crudComponentes.refresh())
						})
					}
				})
			}
			// Si no hay form, Es porque ingresado desde Asignar accesorios checkeds
			else {
				this.$fun.alert(`Asignar ${this.selectedAccessoryCheck.length} Accesorios al equipo selecionado ?`, "question").then((res) => {
					if (res.value) {
						const UsrCreateID = this.$fun.getUserID();
						this.selectedAccessoryCheck.map((accesory) => {
							accesory.AahcID = 0;
							accesory.CgeID = this.form.CgeID
							accesory.AahObservation = null;
							accesory.EayStatus = null;
							accesory.DateDevolution = null;
							accesory.SecStatus = 1;
							accesory.UsrCreateID = UsrCreateID
						})

						const messageResult = "Accesorios asignados correctamente"
						this.saveOrUpdateHistory(this.selectedAccessoryCheck, messageResult, () => {
							this.CgeSerie = '';
							this.form.CgeID = null;
							this.isSaving = false;
							this.filteredEquipments = [];
							this.selectedAccessoryCheck = [];
							this.selectedAccessoryCheckIds = [];
							this.loadDevicesHistoryAccesory(0, () => this.$refs.crudComponentes.refresh())
						})
					}
				})
			}
		},
		saveDevolutionAccessory() {
			if (!this.form.EayStateDevolution > 0) {
				this.$fun.alert("Debe seleccionar un estado de devolución", "info");
				return;
			}

			const history = {
				AahcID: this.form.AahcID,
				EayID: this.form.EayID,
				CgeID: this.form.CgeID,
				EayStatus: this.form.EayStateDevolution,
				AahObservation: this.form.AahObservation,
				DateDevolution: new Date(),
				SecStatus: 1,
				UsrCreateID: this.$fun.getUserID()
			}

			const messageResult = "Accesorio liberado correctamente";
			this.$fun.alert("Liberar Accesorio del equipo ?", "question").then((res) => {
				if (res.value) {
					const update = () => {
						this.form.EayStatusAssignament = 1;
						this.form.EayState = this.form.EayStateDevolution;
						this.save();
						this.dialogUnassignament = false
						this.loadDevicesHistoryAccesory(history.EayID, () => this.$refs.crudComponentes.refresh())
					}
					this.saveOrUpdateHistory([history], messageResult, update)
				}
			})
		},
		openModalDevolution(accesory) {
			this.form = { ...accesory, EayStateDevolution: 0, AahObservation: '' };
			this.dialogUnassignament = true;
		},
		selectEquipment(CgeID) {
			this.form.CgeID = CgeID;
		},
		getEquipmentIcon(type) {
			const icons = {
				'Laptop': 'mdi-laptop',
				'Desktop': 'mdi-desktop-tower',
				'Servidor': 'mdi-server',
				'Impresora': 'mdi-printer',
				'Monitor': 'mdi-monitor',
				'Tablet': 'mdi-tablet'
			}
			return icons[type] || 'mdi-devices'
		},
		changeCheckbox(accesory) {
			const selecteds = this.selectedAccessoryCheckIds.includes(accesory.EayID)
				? [...this.selectedAccessoryCheck, { ...accesory }]
				: this.selectedAccessoryCheck.filter(x => x.EayID != accesory.EayID);
			this.selectedAccessoryCheck = [...selecteds]
		},
		closeDialogUploadMassive() {
			this.dialogUploadMassive = false;
			this.$refs.crudComponentes.refresh();
		},
		load() {
			this.dialogUploadMassive = true;
		},
		closeDialogAssignment() {
			this.dialogAssignament = false;
		},
		changeComponent(TypeComponentValue) {
			let filter = {
				TypeComponent: TypeComponentValue == undefined ? 1 : TypeComponentValue,
				Search: ''
			}

			_serviceBrandComponent.list(filter, this.$fun.getUserID()).then(resp => {
				if (resp.status == 200) {
					this.listBrand = resp.data;
					console.log('this.listBrand ', this.listBrand);
				}
			})
		},
		historyAssignaments(accesory) {
			this.CgeSerie = '';
			this.form = accesory ? { ...accesory } : { CgeID: null, EayID: 0 };
			this.form.CgeID = null;
			this.isSaving = false;
			this.filteredEquipments = [];
			this.loadDevicesHistoryAccesory(accesory ? accesory.EayID : 0, () => this.dialogHistory = true);
		},
		loadDevicesHistoryAccesory(EayID, callback = () => { }) {
			_service.listDevicesHistory({ EayID }, this.$fun.getUserID()).then(resp => {
				this.filtereditemsEquipmentAssignament = resp.status == 200 ? resp.data : [];
				callback();
			})
		},
		saveOrUpdateHistory(history, messageResult, callback = () => { }) {
			// console.log(history)
			_service.SaveHistoryAccessory(history, this.$fun.getUserID()).then((response) => {
				if (response.status == 200) {
					callback();
					this.$fun.alert(messageResult, "success");
				}
			});
		},
				fetchAllPhonePlans() {
			if (this.form.EayAccessory != this.SIM_CARD_TYPE_ID) {
				this.itemsPhonePlans = [];
				return;
			}
			var self = this;
			TicPhonePlanService.pagination(
				{ length: -1, start: 0, column: 0, dir: 'asc', searchText: '', filter: {} },
				this.$fun.getUserID(),
			).then(function (resp) {
				if (resp.status == 200 && resp.data && resp.data.data) {
					self.itemsPhonePlans = resp.data.data;
				}
			});
		},
		updateTableHeaders(accessoryTypeId) {
			const isSim = accessoryTypeId == this.SIM_CARD_TYPE_ID;
			const isCharger = accessoryTypeId == this.CHARGER_TYPE_ID;
			this.config.headers = [
				{ text: "Acción", value: "accion", width: 50 },
				{ text: "ID", value: "EayID", width: 50 },
				{ text: "Nombre", value: "EayAccessoryName" },
				{ text: isSim ? "Operador" : "Marca", value: isSim ? "OperatorName" : "EayBrandName", width: 100 },
				...(isSim ? [] : [{ text: "Modelo", value: "EayModelName", width: 120 }]),
				{ text: isSim ? "IMEI" : isCharger ? "Modelo/Serie" : "Serie", value: "EaySerie", width: 90 },
				...(isSim ? [
					{ text: "Celular", value: "EayPhoneNumber", width: 90 },
					{ text: "PUK", value: "EayPuk", width: 70 },
					{ text: "Plan", value: "CppName" }
				] : []),
				...(isCharger ? [
					{ text: "Potencia", value: "EayWattage", width: 80 },
					{ text: "Tipo Cable", value: "EayCableTypeName", width: 100 },
					{ text: "Cable Datos", value: "EayHasDataCable", align: "center", width: 80 }
				] : []),
				{ text: "Estado", value: "EayState", width: 70, align: "center" },
				{ text: "Tenencia", value: "EayTypeTenureName", width: 100 },
				{ text: "Asignación", value: "CgeTypeEquipmentName", align: "center", width: 150 },
			];
		},
		loadEquipmentModels() {
			const self = this;
			EquipmentModelService.list("", this.$fun.getUserID()).then(function (resp) {
				if (resp.status == 200) {
					self.equipmentModels = resp.data;
				}
			});
		},
		saveNewModel() {
			const self = this;
			const name = this.newModelName.trim();
			if (!name) {
				this.$fun.alert("Ingrese un nombre de modelo", "warning");
				return;
			}
			const model = {
				EmdID: 0,
				EmdName: name,
				SecStatus: 1,
				UsrCreateID: self.$fun.getUserID(),
			};
			EquipmentModelService.save(model, self.$fun.getUserID()).then(function (saveResp) {
				if (saveResp.status == 200) {
					self.$fun.alert("Modelo agregado correctamente", "success");
					self.showAddModelInput = false;
					self.newModelName = '';
					self.loadEquipmentModels();
				}
			});
		},
	},
	mounted() {
		this.updateTableHeaders(this.filter.EayAccessory);
		this.loadEquipmentModels();
	},
}
</script>

<style scoped>
.modern-header {
	background: linear-gradient(135deg, #606060 0%, #525c64 100%);
	padding: 12px;
	color: white;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.header-icon {
	background: rgba(255, 255, 255, 0.2);
	padding: 8px;
	border-radius: 12px;
	backdrop-filter: blur(10px);
}

.header-text,
.header-title {
	flex: 1;
}

.gradient-primary {
	background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.header-left {
	width: 100%;
	display: flex;
	gap: 8px;
	align-items: center;
	flex: 1 1 0%;
}

.header-right {
	display: flex;
	justify-items: center;
	align-items: center !important;
	min-width: 300px;
}

.search-field-header {
	padding: 8px;
	align-items: center !important;
	background-color: rgba(255, 255, 255, 0.15);
	border-radius: 1rem;
	max-width: 250px;
}

.search-field-header>>>.v-input__slot {
	background-color: rgba(255, 255, 255, 0.15) !important;
}

.equipment-card {
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	border: 2px solid transparent;
	position: relative;
	overflow: hidden;
}

.equipment-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.selected-card {
	border-color: var(--v-primary-base);
	background-color: rgba(var(--v-primary-base), 0.02);
}

.equipment-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 8px;
}

@media (max-width:768px) {
	.search-field-header {
		width: 100%;
		max-width: 80%;
	}
}
</style>
